<template>
  <div class="col-md-3">
    <div class="profile-nav">
      <base-widget>
        <template #widget-body>
          <base-widget-body>
            <template #body>
              <news-feed-navigation-profile></news-feed-navigation-profile>
              <news-feed-navigation-link></news-feed-navigation-link>
            </template>
          </base-widget-body>
        </template>
      </base-widget>
    </div>
  </div>
</template>
<script>
import NewsFeedNavigationLink from "@/components/NewsFeedNavigationLink.vue";
import NewsFeedNavigationProfile from "@/components/NewsFeedNavigationProfile.vue";
export default {
  components: {
    NewsFeedNavigationLink,
    NewsFeedNavigationProfile,
  },
};
</script>